<template>
	<div 
	class="list-group-item bg-transparent" 
	v-bind="$attrs"
	@click.stop="$emit('click')">
		<div class="row align-items-center">
			
			<div 
			v-if="title"
			class="col col-title">
				<h5 class="mb-0">
					{{title}}
				</h5>
			</div>

			<div class="col-auto col-value" :class="{small: small}">
				<slot></slot>
			</div>

		</div>
	</div>
</template>

<script>
	export default {

		props: {
			title: {
				type: String,
				default: ''
			},

			small: {
				type: Boolean,
				default: true
			}
		}

	}
</script>